module.exports = __webpack_public_path__ + "static/media/skeletonHead.b92cb8ef.gif";